<template>
    <div class="NoTabImagelistActive" name="ListAll">
        <div class="indexContainer" style="padding-top: 0">
            <div class="productCenterMain">
                <el-row :gutter="20">
                    <el-col :xs="12" :sm="8" v-for="(i,index) in newList" :key="index">
                        <a href="javascript:void(0);" class="newList" @click="rowClick(i)">
                            <div class="newListImg">
                                <img :src="i.picUrl" alt="">
                            </div>
                            <p class="title" v-show="i.name">
                                <span>{{i.name}}
                                    <b v-if="i.isNew == 1">NEW</b>
                                    <b v-if="i.isHot == 1">HOT</b>
                                </span>
                                <span class="dateText">
                                    {{i.releaseTime|dateFormat}}
                                </span>
                            </p>
                            <p class="text">{{i.title}}</p>
                        </a>
                    </el-col>
                </el-row>
                <el-row class="activePaga">
                    <a href="javascript:;" class="stylePaga" @click="handleCurrentChange(1)">{{this.base.pageHome}}</a>
                    <el-pagination
                        style="margin-top:30px;"
                        :page-size="pageSize"
                        layout="prev, pager, next"
                        :current-page.sync="currentPage"
                        @current-change="handleCurrentChange"
                        :total="total">
                    </el-pagination>
                    <a href="javascript:;" class="stylePaga" @click="handleCurrentChange(num)">{{this.base.pageBack}}</a>
                    <span>{{this.pageItem[0]}}{{total}}{{this.pageItem[1]}}</span>
                    <span>{{currentPage}}/{{num}}{{this.pageItem[2]}}</span>
                </el-row>
            </div>
        </div>
        <!--视频弹窗-->
        <video-dialog  ref="video"/>
        <!--图片弹窗-->
        <pic-dialog ref="pic"/>
    </div>
</template>
<script>
import { getPageByParentModule } from '@/api/inner.js';
import VideoDialog from '@/components/common/components/videoDialog'
import PicDialog from '@/components/common/components/picDialog'
export default {
  components: {
    VideoDialog,
    PicDialog
  },
    props: {
        newsData: {}
    },
    data(){
        return{
            num: 1,
            currentPage: 1,
            total: 0,
            pageSize: 6,
            newList:[],
            base:this.$store.getters.base||{},
            pageItem: ['共', '条', '页',]
        }
    },
    created(){
      this.getAllList()
      // this.base = JSON.parse(localStorage.getItem('base'))
      this.pageItem =  this.base.pageItem.split('/')
    },
     methods:{
        async getAllList() {
            let obj = {
                moduleId: this.$route.query.id,
                languageId: this.newsData.languageId,
                page: {
                    page: this.currentPage,
                    size: this.pageSize,
                }
            }
            await getPageByParentModule(obj).then(res=> {
                this.newList = res.data.list;
                this.total = res.data.page.total;
                this.page = res.data.page.page;
                this.num = Math.ceil(res.data.page.total / res.data.page.size);
            })
        },
        handleData() {
          let data = [];
          for(let v of this.newList) {
            if(Number(v.type) === 1) {
              data.push(v);
            }
          }
          return data;
        },
        rowClick(row){
          if(row.isLink && row.linkUrl){
            window.open(row.linkUrl,'_blank')
            return
          }
          if(Number(row.type) === 0) {
            this.$router.push({
              name: 'ARTICLEDETAIL',
                query: {
                    languageId: this.$route.query.languageId,
                    model: this.$route.query.model,
                    modelId: this.$route.query.id,
                    level: this.$route.query.level,
                    type: this.$route.query.type,
                    id: row.id
                }
            });
          } else if(Number(row.type) === 1) {
            let item = this.handleData();
            this.$refs.pic.open(item);
          } else if(Number(row.type) === 2) {
            this.$refs.video.open(row);
          }
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getAllList()
        }
    },
    watch: {
      $route(val) {
        this.getAllList()
      }
    }
}
</script>
<style lang="less" scoped>
.NoTabImagelistActive{
 .productCenterMain{
        // padding-top: 30px;
        /deep/.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
            color: #d11a2e;
        }
        /deep/.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover{
            color: #d11a2e;
        }
    }
    .newList{
        border-radius: 4px;
        background: #f7f7f7;
        display: inline-block;
        width: 100%;
        overflow: hidden;
        margin-bottom: 10px;
        .newListImg{
            width: 100%;
            height: 102px;
            overflow: hidden;
            img{
                height: 100%;
                display: block;
            }
        }
        p{
            line-height: 24px;
        }
        p.title{
            padding: 10px;
            line-height: 24px;
            text-align: left;
            margin: 0;
            overflow: hidden; /*隐藏*/
            white-space: nowrap;  /*不换行*/
            text-overflow: ellipsis;  /* 超出部分省略号 */
            width: 100%;
            box-sizing: border-box;
            span{
                color: #d11a2e;
                display: inline-block;
                // width: 100%;
                font-size: 14px;
                b{
                    color: #d11a2e;
                    font-style: normal;
                    border-radius: 30px;
                    border: 1px solid #d11a2e;
                    display: inline-block;
                    font-weight: normal;
                    padding: 0 3px;
                    font-size: 12px;
                    line-height: 16px;
                    height: 16px;
                }
            }
            .dateText{
                color: #666;
                float: left;
                font-size: 14px;
                width: 100%;
            }
        }
        p.text{
            height: 56px;
            overflow: hidden;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            margin: 5px 10px 10px;
            padding: 0;
            text-align: left;
        }
    }
    .newList:hover{
        background: #f4f4f4;
        .newListImg img{
            transform: scale(1.2);
            transition: all 3s;
        }
    }
    .activePaga{
        width: 100%;
        .stylePaga{
            border: 1px solid #eee;
            background: #fff;
            display: inline-block;
            line-height: 36px;
            padding: 0 12px;
            font-size: 14px;
        }
        .stylePaga:hover{
            color:#fff;
            background: #d11a2e;
        }
        span{
            padding: 0 5px;
        }
        .el-pagination{
            display: inline-block;
            font-size: 14px;
            line-height: 36px;
        }
        /deep/.el-pagination .btn-next, /deep/.el-pagination .btn-prev{
            // background: #fff;
            // display: inline-block;
            // min-width:36px;
            border: 1px solid #eee;
            padding:0;
            height: 36px;
            margin: 0 4px;
            i{
                display: inline-block;
                line-height: 36px;
                min-width:36px;
            }
        }
        /deep/.el-pager li{
            line-height: 36px;
            font-size: 14px;
            background: #fff;
            border: 1px solid #eee;
            height: 36px;
            min-width: 36px;
            margin: 0 4px;
        }
        /deep/.el-pager li.active,/deep/.el-pager li:hover,/deep/.el-pagination .btn-next:hover, /deep/.el-pagination .btn-prev:hover{
            color:#fff;
            background: #d11a2e;
        }
    }
    @media (min-width: 768px) and (max-width: 1024px) {
        .newList{
            p.title {
                span{
                    font-size: 16px;
                }
                .dateText{
                    font-size: 14px;
                    width: auto;
                    float: right;
                }
            }
            .newListImg{
                height: 132px;
            }

        }

    }
    @media (min-width: 1024px) and (max-width: 1200px) {
        .newList{
            p.title {
                span{
                    font-size: 16px;
                }
                .dateText{
                    font-size: 14px;
                    float: right;
                    width: auto;
                }
            }
            .newListImg{
                height: 152px;
            }
        }
    }
    @media only screen and (min-width: 1200px){
        .newList{
            p.title {
                span{
                    font-size: 16px;
                }
                .dateText{
                    font-size: 14px;
                    float: right;
                    width: auto;
                }
            }
            .newListImg{
                height: 172px;
            }
        }
    }


}

</style>



// WEBPACK FOOTER //
// src/components/item/listAll.vue